var wishlist_items = JSON.parse(localStorage.getItem('wishlist_items')) || [];
window.toggleWishlist = function(isWishlist, el, handle) {
    var index = wishlist_items.indexOf(handle);

    // If handle is not in the array, add it
    if (index === -1) {
        wishlist_items.push(handle);
        console.log(handle + ' added to wishlist');
    } else {
        // If handle is already in the array, remove it
        wishlist_items.splice(index, 1);
        console.log(handle + ' removed from wishlist');
    }
    localStorage.setItem('wishlist_items', JSON.stringify(wishlist_items));
    $(el).toggleClass('active');

    var wishlist_items_live = JSON.parse(localStorage.getItem('wishlist_items')) || [];

    var wishlistCountLive = wishlist_items_live.length;

    if(wishlist_items_live.length > 0) {
        jQuery('.header-account-link--wishlist').addClass('active');
    } else {
        jQuery('.header-account-link--wishlist').removeClass('active');
    }


}

var wishlist_items = JSON.parse(localStorage.getItem('wishlist_items')) || [];

var wishlistCount = wishlist_items.length;

if(wishlist_items.length > 0) {
    jQuery('.header-account-link--wishlist').addClass('active');
}

var wishlistButton = jQuery('.add-to-wishlist');

if($('.product-grid').length) {
  $('.product-grid .product-block').each(function() {
     if (wishlist_items.includes($('.add-to-wishlist', this).data('handle'))) {
       $('.add-to-wishlist', this).addClass('active');
     }
  });
}

if(jQuery('body').hasClass('template-product')) {
    if (wishlist_items.includes($('.add-to-wishlist').data('handle'))) {
       $('.add-to-wishlist').addClass('active');
    }
    var checkInterval = setInterval(function() {
        var checked = jQuery('.swatches [option-name="Size"] ul li[aria-checked="true"]').length;
        if (checked > 0) {
            jQuery('#size-notifier').hide();
            clearInterval(checkInterval);
        }
    }, 500);

    jQuery('.quantity-submit-row__submit--atc').on('click', function() {
        if(jQuery('.swatches [option-name="Size"] ul li[aria-checked="true"]').length == 0) {
            jQuery('#size-notifier').fadeIn();
        }
    });
}

if ($('#wishlist-container').length) {
    var wishlistContainer = $('#wishlist-container');
    var whatsappMessage = '';
    var totalItems = wishlist_items.length;
    var completedRequests = 0;

    // Clear the container to avoid duplicates
    wishlistContainer.empty();

    $.each(wishlist_items, function(index, item) {
        $.ajax({
            url: '/products/' + item + '.json',
            type: 'GET',
            dataType: 'json',
            success: function(productData) {
                var handle = productData.product.handle;
                var title = productData.product.title;
                var price = productData.product.variants[0].price;
                var image = productData.product.image?.src || '';

                // Append product to wishlist container
                wishlistContainer.append(
                    '<div class="wishlist-item">' +
                        '<div class="wishlist-item__image">' +
                            '<a href="/products/' + handle + '"><img src="' + image + '&width=660" alt="' + title + '" /></a>' +
                        '</div>' +
                        '<span class="wishlist-item__title"><a href="/products/' + handle + '">' + title + '</a></span>' +
                        '<p class="wishlist-item__price">£' + price + '</p>' +
                        '<span class="add-to-wishlist active" onclick="toggleWishlist(true, this, \''+productData.product.handle+'\')"><svg role="img" aria-hidden="true" viewBox="0 0 512 512" class="icon icon-wishlist w-h-"><g><g><path d="M474.644,74.27C449.391,45.616,414.358,29.836,376,29.836c-53.948,0-88.103,32.22-107.255,59.25 c-4.969,7.014-9.196,14.047-12.745,20.665c-3.549-6.618-7.775-13.651-12.745-20.665c-19.152-27.03-53.307-59.25-107.255-59.25 c-38.358,0-73.391,15.781-98.645,44.435C13.267,101.605,0,138.213,0,177.351c0,42.603,16.633,82.228,52.345,124.7 c31.917,37.96,77.834,77.088,131.005,122.397c19.813,16.884,40.302,34.344,62.115,53.429l0.655,0.574 c2.828,2.476,6.354,3.713,9.88,3.713s7.052-1.238,9.88-3.713l0.655-0.574c21.813-19.085,42.302-36.544,62.118-53.431 c53.168-45.306,99.085-84.434,131.002-122.395C495.367,259.578,512,219.954,512,177.351 C512,138.213,498.733,101.605,474.644,74.27z M309.193,401.614c-17.08,14.554-34.658,29.533-53.193,45.646 c-18.534-16.111-36.113-31.091-53.196-45.648C98.745,312.939,30,254.358,30,177.351c0-31.83,10.605-61.394,29.862-83.245 C79.34,72.007,106.379,59.836,136,59.836c41.129,0,67.716,25.338,82.776,46.594c13.509,19.064,20.558,38.282,22.962,45.659 c2.011,6.175,7.768,10.354,14.262,10.354c6.494,0,12.251-4.179,14.262-10.354c2.404-7.377,9.453-26.595,22.962-45.66 c15.06-21.255,41.647-46.593,82.776-46.593c29.621,0,56.66,12.171,76.137,34.27C471.395,115.957,482,145.521,482,177.351 C482,254.358,413.255,312.939,309.193,401.614z"></path></g></g></svg></span>'+
                    '</div>'
                );

                // Append product info to WhatsApp message
                whatsappMessage += title + '\n£' + price + '\nhttps://sandbanksco.com/products/' + handle + '\n\n';
            },
            error: function(error) {
                console.error('Error fetching product information for ' + item + ':', error);
            },
            complete: function() {
                completedRequests++;
                if (completedRequests === totalItems) {
                    // All AJAX calls completed
                    var encodedMessage = encodeURIComponent(whatsappMessage.trim());
                    $('.share-wishlist-whatsapp').attr('href', 'https://api.whatsapp.com/send?text=' + encodedMessage).css('display', 'flex');
                }
            }
        });
    });
}

// jQuery(function($) {
//     if ($('body').hasClass('template-product')) {
//         function getSwatchProductGroup() {
//             var $swatches = $('.swatch-view-item .swatch-group-selector');

//             // Look for a swatch with the real swatch image loaded
//             var isReady = false;
//             $swatches.each(function() {
//                 var styleAttr = $(this).find('.star-set-image').attr('style') || '';
//                 if (styleAttr.includes('cdn.starapps.studio')) {
//                     isReady = true;
//                     return false; // break loop
//                 }
//             });

//             if (!isReady) {
//                 return setTimeout(getSwatchProductGroup, 100);
//             }

//             var swatchProductGroup = [];

//             $swatches.each(function() {
//                 var $this = $(this);
//                 var swatchValue = $this.attr('data-value') || '';
//                 var swatchUrl = $this.attr('swatch-url') || '';
//                 var handle = swatchUrl.replace('/products/', '');

//                 // Grab swatch image from style attribute
//                 var styleAttr = $this.find('.star-set-image').attr('style') || '';
//                 var imgMatch = styleAttr.match(/url\((['"]?)(.*?)\1\)/);
//                 var imgUrl = imgMatch ? imgMatch[2] : '';

//                 // Only add if not already in the array
//                 var exists = swatchProductGroup.some(function(item) {
//                     return item.handle === handle || item.value === swatchValue;
//                 });

//                 if (!exists) {
//                     swatchProductGroup.push({
//                         value: swatchValue,
//                         handle: handle,
//                         image: imgUrl
//                     });
//                 }
//             });

//             window.swatchProductGroup = swatchProductGroup;

//             var $ul = $('<ul class="product-swatches"></ul>');
//             var maxToShow = 6;

//             swatchProductGroup.forEach(function(swatch, index) {
//                 var $li = $('<li></li>');
//                 var $link = $('<a></a>')
//                     .attr('href', '/products/' + swatch.handle)
//                     .attr('title', swatch.value)
//                     .attr('aria-label', swatch.value);
//                 var $img = $('<img>')
//                     .attr('src', swatch.image)
//                     .attr('alt', swatch.value);

//                 $link.append($img);
//                 $li.append($link);

//                 // Hide anything after maxToShow initially
//                 if (index >= maxToShow) {
//                     $li.addClass('swatch-hidden').hide();
//                 }

//                 $ul.append($li);
//             });

//             var remaining = swatchProductGroup.length - maxToShow;
//             if (remaining > 0) {
//                 var $more = $('<li class="swatch-more">+' + remaining + ' other colour' + (remaining > 1 ? 's' : '') + '</li>');
//                 $ul.append($more);

//                 // Toggle hidden swatches on click
//                 $more.on('click', function() {
//                     $ul.find('.swatch-hidden').show();
//                     $(this).remove(); // remove the "+X other colours" link
//                 });
//             }

//             // $('#swatches-load').html($ul);

//             var $swatchUl = $('.swatches [option-name="Size"] ul');

//             if ($swatchUl.length) {
//                 var $select = $('<select class="swatch-select"></select>');

//                 // Loop through all LI items and build <option>
//                 $swatchUl.find('li').each(function() {
//                     var $li = $(this);
//                     var value = $li.attr('orig-value');
//                     var label = $li.attr('aria-label') || value;
//                     var $btn = $li.find('.swatch-button');

//                     if (value) {
//                         var $option = $('<option>')
//                             .val(value)
//                             .text(label)
//                             .data('target', $btn); // store reference to button
//                         $select.append($option);
//                     }
//                 });

//                 // Hide the UL
//                 $swatchUl.hide();

//                 // Insert the select after the UL
//                 $swatchUl.after($select);

//                 // Handle change → trigger original click
//                 $select.on('change', function() {
//                     var selectedVal = $(this).val();
//                     var $option = $(this).find('option:selected');
//                     var $btn = $option.data('target');

//                     if ($btn && $btn.length) {
//                         $btn.trigger('click');
//                     }
//                 });
//             }


//         }

//         getSwatchProductGroup();
//     }
// });


jQuery(document).ready(function($) {

    if (jQuery('.product-block').length) {
        
        function formatTitle($el) {
            const text = $el.text();
            if (text.includes(' - ')) {
                const parts = text.split(' - ');
                $el.html(parts[0] + '<span>' + parts[1] + '</span>');
            }
        }

        // Main observer that reacts when a title’s text changes
        const titleObserver = new MutationObserver(function(mutationsList) {
            mutationsList.forEach(function(mutation) {
                if (mutation.type === 'childList' || mutation.type === 'characterData') {
                    const $target = jQuery(mutation.target).closest('.product-block__title');
                    if ($target.length) formatTitle($target);
                }
            });
        });

        // Helper function to start observing each title
        function observeTitle($title) {
            titleObserver.observe($title[0], { childList: true, characterData: true, subtree: true });
        }

        // Observe all existing titles on page load
        jQuery('.product-block__title').each(function() {
            observeTitle(jQuery(this));
        });

        // Secondary observer: detects new product blocks added (e.g. via “load more”)
        const containerObserver = new MutationObserver(function(mutationsList) {
            mutationsList.forEach(function(mutation) {
                jQuery(mutation.addedNodes).each(function() {
                    // Check for newly added product blocks or titles
                    const $newTitles = jQuery(this).find('.product-block__title');
                    if ($newTitles.length) {
                        $newTitles.each(function() {
                            observeTitle(jQuery(this));
                        });
                    }

                    // Also handle if the added node itself *is* a title
                    if (jQuery(this).is('.product-block__title')) {
                        observeTitle(jQuery(this));
                    }
                });
            });
        });

        // Watch the document body for new product blocks being added
        containerObserver.observe(document.body, { childList: true, subtree: true });
    }

    if($('.section-recently-viewed-products').length) {
        // Wrap sections in a tab container
        var $related = $('.section-related-products');
        var $recent  = $('.section-recently-viewed-products');

        if ($related.length && $recent.length) {
            // Wrap both in a parent
            var $tabWrapper = $('<div class="product-tabs"></div>');
            $related.add($recent).wrapAll($tabWrapper);

            // Inject tab nav
            var $nav = $(`
            <ul class="product-tab-nav">
                <li class="tab-link active" data-tab="related">Related Products</li>
                <li class="tab-link" data-tab="recent">Recently Viewed</li>
            </ul>
            `);
            $('.product-tabs').prepend($nav);

            // Add IDs for targeting
            $related.attr('id', 'tab-related').addClass('tab-content active');
            $recent.attr('id', 'tab-recent').addClass('tab-content').hide();

            // Tab click behaviour
            $('.product-tab-nav .tab-link').on('click', function() {
            var tab = $(this).data('tab');

            // Toggle active states
            $('.product-tab-nav .tab-link').removeClass('active');
            $(this).addClass('active');

            $('.tab-content').hide().removeClass('active');
            $('#tab-' + tab).show().addClass('active');
            });

            function loadRecentlyViewedIntoSection() {
                console.log('loading-recently');
                var container = document.getElementById('recently-viewed-grid');
                if (!container) return;

                var viewed = JSON.parse(localStorage.getItem('recentlyviewed') || '[]');
                if (viewed.length === 0) return;

                container.innerHTML = '';

                var requests = viewed.map(function(handle) {
                    return fetch('/products/' + handle + '.json')
                    .then(r => r.json())
                    .then(function(data) {
                        var product = data.product;
                        if (!product || !product.images || product.images.length === 0) return '';

                        var firstImage = product.images[0].src;
                        var link = '/products/' + product.handle;
                        var price = (product.variants[0].price / 1).toFixed(2);

                        return `
                <product-block class="product-block" data-product-id="${product.id}">
                <div class="block-inner">
                    <div class="block-inner-inner">
                    <div class="image-cont image-cont--same-aspect-ratio">
                        <a class="product-link" href="${link}">
                        <div class="image-label-wrap">
                            <div>
                            <div class="product-block__image product-block__image--primary product-block__image--active">
                                <img src="${firstImage}" alt="${product.title}" loading="lazy" class="theme-img">
                            </div>
                            </div>
                        </div>
                        </a>
                    </div>
                    <div class="product-block__detail align-ltr-left">
                        <div class="inner">
                        <div class="innerer">
                            <a class="product-link" href="${link}">
                            <div class="product-block__title">${product.title}</div>
                            <div class="product-price product-price--block">
                                <div class="price">
                                <div class="price__default">
                                    <span class="price__current">£${price}</span>
                                </div>
                                </div>
                            </div>
                            </a>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                </product-block>`;
                    });
                });

                Promise.all(requests).then(function(htmlSnippets) {
                    htmlSnippets.forEach(function(html) {
                    if (!html) return;
                    var slide = document.createElement('div');
                    slide.className = 'slider__item';
                    slide.innerHTML = html.trim();
                    container.appendChild(slide);
                    });

                    document.querySelectorAll('.recently-viewed-products carousel-slider').forEach(function(el) {
                    if (typeof el.refresh === 'function') {
                        el.refresh();
                    }
                    });
                });
                }


            jQuery('.tab-link[data-tab="recent"]').on('click', function() {
                if(!jQuery(this).hasClass('loaded-recently')) {
                    loadRecentlyViewedIntoSection();
                    jQuery(this).addClass('loaded-recently');
                }
            });
        }
    }
});

jQuery(window).on('load', function() {
    jQuery('.template-product .input-row').fadeIn();
});

jQuery('.section-footer__menu-block .section-footer__title').on('click', function() {
    jQuery(this).toggleClass('active');
    jQuery(this).next('ul').slideToggle();
});

jQuery(document).ready(function() {
  var $timer = jQuery('.countdown-timer');
  if (!$timer.length) return;

  var endDateStr = $timer.text().trim();
  var endDate = new Date(endDateStr).getTime();

  function updateCountdown() {
    var now = new Date().getTime();
    var diff = endDate - now;

    if (diff <= 0) {
      $timer.hide();
      jQuery('.buy-buttons-row, .sticky-atc').addClass('timer-ended');
      clearInterval(interval);
      return;
    }

    var days = Math.floor(diff / (1000 * 60 * 60 * 24));
    var hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((diff % (1000 * 60)) / 1000);

    var parts = [];
    if (days > 0) parts.push('<strong>' + days + '</strong> ' + (days === 1 ? 'Day' : 'Days'));
    if (hours > 0 || days > 0) parts.push('<strong>' + hours + '</strong> ' + (hours === 1 ? 'Hour' : 'Hours'));
    if (minutes > 0 || hours > 0 || days > 0) parts.push('<strong>' + minutes + '</strong> ' + (minutes === 1 ? 'Minute' : 'Minutes'));
    parts.push('<strong>' + seconds + '</strong> ' + (seconds === 1 ? 'Second' : 'Seconds'));

    $timer.html(parts.join(' '));
  }

  updateCountdown(); // initial render
  var interval = setInterval(updateCountdown, 1000);
});


jQuery(window).on('load', function () {
  const cfg = window.freeGiftConfig;
  if (!cfg) return;

  const FREE_ID = String(cfg.freeGiftVariantId);
  const THRESHOLD = cfg.threshold;

  // Evaluate whether gift should be added or removed
  async function evaluateGift() {
    const cart = await fetch('/cart.js').then(r => r.json());
    const subtotal = cart.items_subtotal_price;
    const hasGift = cart.items.some(i => String(i.variant_id) === FREE_ID);

    // Check if any item is product_type: 'Jacket'
    const eligible = cart.items.some(i => i.product_type === 'Jacket');

    // Add gift only if threshold met AND a jacket exists
    if (subtotal >= THRESHOLD && eligible && !hasGift) {
        if (localStorage.getItem('gf-removed') === 'true') {
            console.log('gifting removed');
        } else {
            await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: FREE_ID, quantity: 1 })
            });
            return refreshCartUI();
        }
    }

    // Remove gift if subtotal too low OR no jacket present
    if ((subtotal < THRESHOLD || !eligible) && hasGift) {
        const updates = {};

        cart.items.forEach(item => {
        updates[item.key] =
            String(item.variant_id) === FREE_ID ? 0 : item.quantity;
        });

        await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates })
        });

        return refreshCartUI();
    }
}

  // Refresh Symmetry's cart drawer
  async function refreshCartUI() {
    const response = await fetch('/?sections=cart-drawer');
    const data = await response.json();
    const html = data['cart-drawer'];

    const drawer = document.querySelector('cart-drawer');
    if (!drawer || !drawer.updateFromCartChange) return;

    drawer.updateFromCartChange(html);

    document.dispatchEvent(
      new CustomEvent('dispatch:cart-drawer:refresh')
    );
  }

  // Initial load
  evaluateGift();

  // Symmetry triggers this after AJAX cart updates
  document.addEventListener('cart:refresh', evaluateGift);

  // Patch fetch to detect /cart/add
  const originalFetch = window.fetch;
  window.fetch = async function (input, init) {
    const result = await originalFetch(input, init);

    const url = typeof input === 'string' ? input : input.url;
    if (url && url.includes('/cart/')) {
      evaluateGift();
    }

    return result;
  };

  // Safety for legacy Shopify handlers
  if (window.Shopify && Shopify.onCartUpdate) {
    const original = Shopify.onCartUpdate;
    Shopify.onCartUpdate = function () {
      original.apply(this, arguments);
      evaluateGift();
    };
  }
});


(function ($) {
    $(document).on('click', '.product-card__size-indicatr--mobile .variant-size:not(.is-unavailable)', function () {
        var $block = $(this).closest('.product-block');
        var id = $(this).data('variant-id');
        var $btn = $block.find('.product-card__size-indicatr__button');
        $(this).addClass('active').siblings().removeClass('active');
        $btn.attr('data-variant-id', id).data('variant-id', id);
        $btn.prop('disabled', false);
    });
    $(document).on('click', '.js-add-variant', function (e) {
      e.preventDefault();

      var $el = $(this);
      if ($el.hasClass('is-unavailable') || $el.attr('aria-disabled') === 'true') return;

      var variantId = $el.data('variant-id');
      if (!variantId) return;

      $el.addClass('is-loading');

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: { id: variantId, quantity: 1 },

        success: function () {
          // 1) Tell Symmetry to re-render drawer contents
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));

          // 2) Open the drawer
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));

          jQuery('.product-card__size-indicatr').removeClass('active');

          // Optional quick feedback
          $el.addClass('is-added');
          setTimeout(function () { $el.removeClass('is-added'); }, 800);
        },

        error: function (xhr) {
          console.error('Add to cart failed:', xhr.responseText);
          alert('Sorry — could not add that size to cart.');
        },

        complete: function () {
          $el.removeClass('is-loading');
        }
      });
    });
  })(jQuery);


  jQuery('.quickbuytoggle').on('click', function(e) {
    e.preventDefault();
    jQuery('.product-card__size-indicatr__button').prop('disabled', true);
    jQuery('.product-card__size-indicatr--mobile img').css('opacity', 0);
    jQuery(this).parents('.product-block').find('.product-card__size-indicatr__title-close strong').html(jQuery(this).parents('.product-block').find('.product-block__title').html());
    jQuery(this).parents('.product-block').find('.product-card__size-indicatr__price').html(jQuery(this).parents('.product-block').find('.product-price--block').html());
    jQuery(this).parents('.product-block').find('.product-card__size-indicatr--mobile img').attr('src', jQuery(this).parents('.product-block').find('.product-block__image img').attr('src'));
    setTimeout(function() {
        jQuery('.product-card__size-indicatr--mobile img').css('opacity', 1);
    }, 300);
    jQuery('.product-card__size-indicatr').removeClass('active');
    jQuery(this).next('.product-card__size-indicatr').addClass('active');
  });

jQuery(window).on('load', function() {
  if(jQuery('body').hasClass('template-product')) {
    if(jQuery('.main-image video').length) {
        jQuery('.main-image video').removeAttr('controls');
    }
  }

  if (jQuery('.product-block').length) {
    
    // Function to fetch and update size indicators for a product block
    function updateSizeIndicators($productBlock) {
        const handle = $productBlock.attr('swatch-generated');
        if (!handle) return;

        jQuery.getJSON(`/products/${handle}.js`, function (product) {

            // Find the size option index
            let sizeIndex = -1;
            product.options.forEach((option, index) => {
            if (option.name && option.name.toLowerCase() === 'size') sizeIndex = index;
            });
            if (sizeIndex === -1) return;

            // IMPORTANT: render for each container separately (desktop vs mobile)
            $productBlock.find('.product-card__size-indicatr').each(function () {
            const $container = jQuery(this);
            const $options = $container.find('.product-card__size-indicatr__options');
            if (!$options.length) return;

            const isMobile = $container.hasClass('product-card__size-indicatr--mobile');
            let html = '';

            if (product.variants.length > 1) {
                product.variants.forEach(function (variant) {
                const sizeValue = variant.options[sizeIndex];
                const isAvailable = variant.available;
                const unavailableClass = isAvailable ? '' : ' is-unavailable';
                const ariaDisabled = isAvailable ? '' : ' aria-disabled="true"';

                if (isMobile) {
                    html += `<span class="variant-size${unavailableClass}" data-variant-id="${variant.id}"${ariaDisabled}>${sizeValue}</span>`;
                } else {
                    html += `<span class="variant-size js-add-variant${unavailableClass}" data-variant-id="${variant.id}"${ariaDisabled}>${sizeValue}</span>`;
                }
                });
            } else {
                const variant = product.variants[0];
                const isAvailable = variant.available;
                const unavailableClass = isAvailable ? '' : ' is-unavailable';
                const ariaDisabled = isAvailable ? '' : ' aria-disabled="true"';

                if (isMobile) {
                html += `<span class="variant-size${unavailableClass}" style="width:70px;text-transform:uppercase;" data-variant-id="${variant.id}"${ariaDisabled}>One Size</span>`;
                } else {
                html += `<span class="variant-size js-add-variant${unavailableClass}" style="width:70px;text-transform:uppercase;" data-variant-id="${variant.id}"${ariaDisabled}>One Size</span>`;
                }
            }

            $options.html(html);
            });
        });
        }

    // Main observer that reacts when attributes change on product blocks
    const sizeObserver = new MutationObserver(function(mutationsList) {
        mutationsList.forEach(function(mutation) {
            // Only trigger when the swatch-generated attribute is added/changed
            if (mutation.type === 'attributes' && mutation.attributeName === 'swatch-generated') {
                const $productBlock = jQuery(mutation.target);
                if ($productBlock.attr('swatch-generated')) {
                    updateSizeIndicators($productBlock);
                }
            }
        });
    });

    // Helper function to start observing each product block
    function observeProductBlock($block) {
        sizeObserver.observe($block[0], { attributes: true, attributeFilter: ['swatch-generated'] });
    }

    // Observe all existing product blocks on page load
    jQuery('.product-block').each(function() {
        observeProductBlock(jQuery(this));
    });

    // Secondary observer: detects new product blocks added (e.g. via "load more")
    const containerObserver = new MutationObserver(function(mutationsList) {
        mutationsList.forEach(function(mutation) {
            jQuery(mutation.addedNodes).each(function() {
                // Check for newly added product blocks
                const $newBlocks = jQuery(this).find('.product-block');
                if ($newBlocks.length) {
                    $newBlocks.each(function() {
                        observeProductBlock(jQuery(this));
                    });
                }

                // Also handle if the added node itself *is* a product block
                if (jQuery(this).is('.product-block')) {
                    observeProductBlock(jQuery(this));
                }
            });
        });
    });

    // Watch the document body for new product blocks being added
    containerObserver.observe(document.body, { childList: true, subtree: true });
}
});